import { Tooltip2 } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const Tooltip = styled(Tooltip2)<{ isDesktop: boolean }>`
  ${({ isDesktop }) =>
    !isDesktop &&
    `
      @keyframes bound {
        0% {
          top: -1px;
        }
        10% {
          top: -5px;
        }
        20% {
          top: -1px;
        }
        30% {
          top: -5px;
        }
        40% {
          top: -1px;
        }
      }
      will-change: top;
      animation: bound 2s ease 1s 2 alternate;
    `}
`;
